// extracted by mini-css-extract-plugin
module.exports = {"container":"AlertText_container__1pfOE","container_title":"AlertText_container_title__2NZA4","container_text":"AlertText_container_text__2dUC3"};